<template>


  <div class="children-container">
    <div class="children-module-name"><span v-if="viewData.mail">修改邮箱</span><span v-else>绑定邮箱</span></div>
    <div class="children-module-info">
      <div style="margin-bottom: 40px;display: flex;align-items: center;">
        <div style="margin-right: 5px;"><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAABu0lEQVQ4jZ3UzYtOcRQH8M8jL82CmqawEGVH8lJKtrKwUyjvIUp2ksxCz4JJGiVZEAqFZsmGEv+AhcUU0SivKVJDssCg0cl5mjv33sfz8N3c3++8fH/nnt/3/BqOH9EFLuMn9pdDx5uDk/ZTu2FDX8XSBkXCXszDo5rQq1lhBY2B/hV4Nd4c/BS+KYWAHRjGtlLSzEjA21wXsR0PsbVlKxKexyWsz/1y3MHHPGg417exJGM24hwutkiKv/wLB3K9CTcwgn14kPbVOFSoakM3l7IoyW5hF8YKvjhgKP3xXYZnZcK+7M07fEcT77GnRNbCWB4UREdj3Rjo78EcfIkevsZLXMiEdbiGbxWqCXzF9YyVvQ+O51HhUszCm6y4N2+1EyJ+dsYcxGl8DoIXpcRRLOxAFpiPD/5My2jmTZJNC/dSkz0VzwTCtxN3y446wmOYm9MxveJlRvY4LvNE2Vknm5GclqHU25nUYQOrcDhbsqUsmXaEgZtYiZM5BdPS/iMnZTMeV7L+QigTdmMxFqQtbv9JjmAtOj1fIYUQcRFXsPd/CWO2T2Ft7u/XyOyfCGMi4o08G3LDGjxtG43f/cxjjuxJjRYAAAAASUVORK5CYII="
            alt=""></div>
        <div class="tips-text" v-if="viewData.mail">您正在进行修改邮箱的操作</div>
        <div class="tips-text" v-else>您正在进行绑定邮箱的操作</div>
      </div>
      <a-form-model dialogClass="custom-dialog" :maskClosable="false" ref="formModel" :rules="formModelRules" :model="formModel" layout="vertical"
        :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }">
        <a-form-model-item label="已绑定邮箱" v-if="viewData.mail">
          <div style="padding-top: 7px;color: #999">{{viewData.mail}}</div>
        </a-form-model-item>
        <a-form-model-item label="邮箱" prop="mail">
          <a-input :placeholder="viewData.mail? '请输入要更换的邮箱': '请输入邮箱'" v-model="formModel.mail"></a-input>
        </a-form-model-item>
        <a-form-model-item label="验证码" prop="code">
          <a-input style="width: 120px;margin-right: 20px;" placeholder="请输入验证码" v-model="formModel.code"></a-input>
          <a-button style="width: 120px;" v-if="codeFlag == true">{{codeStr}}</a-button>
          <a-button style="width: 120px;" v-else type="primary" @click="getCode" :disabled="$store.state.requestLoading">获取验证码</a-button>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 8, offset: 3 }">
          <a-button type="primary" block @click="submitData">{{viewData.mail ? '更换邮箱' : '确定'}}</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
  import * as Api from './api';
  import * as commonApi from '@/commonApi';

  export default {
    data() {
      let validateMail = (rule, value, callback) => {
        if (!commonApi.EmailReg.test(value)) {
          callback(new Error("请输入正确的邮箱"));
        }
        callback();
      };
        
  
      return {
        formModel: {
          mail: '',
          code: ''
        },
        myMail: '',
        formModelRules: {
          mail: [{ required: true, message: '请输入邮箱', trigger: 'change' },{ validator: validateMail, trigger: 'change' }],
          code: [{ required: true, message: '请输入验证码', trigger: 'change' }]
        },
        timeId: null,
        codeStr: '',
        time: 60,
        codeFlag: false,
        viewData: {
          mail: ''
        }
      };
    },
    mounted() {
      this.getMyMail();
    },
    methods: {
      // 获取邮箱
      async getMyMail() {
        let res = await Api.GetMyMail({});
        if (res && res["code"] == "0") {
          if (res.mail) {
            this.viewData.mail = res.mail;
          }
        } else {
          this.$message.error(res.message);
        }
      },
      // 提交数据 
      async submitData() {
        this.$refs.formModel.validate(async valid => {
          if (valid) {
            let res = await Api.ChangeMail(this.formModel);
            if (res && res['code'] == '0') {
              this.$message.success(res.message);
              this.formModel.code = '';
              this.formModel.mail = ''
              if (this.timeId) {
                clearInterval(this.timeId)
              }
              this.getMyMail();
              
            } else {
              this.$message.error(res.message);
            }
          }
        });
      },
      // 获取验证码
      async getCode() {
        if (!commonApi.EmailReg.test(this.formModel.mail)) {
          this.$message.error('请输入正确的邮箱');
          return;
        }
        let res = await Api.SendCodeToMail({ mail: this.formModel.mail });
        if (res && res['code'] == '0') {
          this.codeTime()
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      },
      // 验证码倒计时
      codeTime() {
        this.codeFlag = true;
        this.codeStr = `${this.time}s后重新获取`
        this.timeId = setInterval(() => {
          if (this.time > 1) {
            this.time--;
            this.codeStr = `${this.time}s后重新获取`
          } else {
            this.codeFlag = false;
            clearInterval(this.timeId)
            this.time = 60
          }

        }, 1000);
      },
    },
  };
</script>

<style lang="less">
  .tips-text {
    font-size: 14px;
    font-weight: 500;
    color: #007F76;
    line-height: 38px;
    padding-top: 2px;
  }

  .code {
    background-color: #007F76;
    font-size: 12px;
    color: #fff;
    font-weight: 500;
  }
  .children-module-content {
    background-color: #fff;
  }
</style>